<div class="row">
    <div class="col-xs-12">
        <div class="card card--box card--box--dashboard">
            <div class="col-md-5 col-xs-12 p-0 mx-auto card--box--dashboard__header">
                <h2 class="header">
                    {{ 'Dashboard' | translate }}
                </h2>
            </div>
            <div class="col-md-7 col-xs-12 p-0 mx-auto card--box--dashboard__filter">
                <div class="col-xs-3 filter__item">
                    <div class="form-group mat-select-pill">
                        <mat-select class="mat-select-pill__select" [placeholder]="'Select Year' | translate"
                                    [disabled]="filterTime['type'] !== 'YEAR' && filterTime['type'] !== 'MONTH'"
                                    [(ngModel)]="filterParams.year"
                                    (ngModelChange)="setDateRange()">
                            <mat-option *ngFor="let year of years" [value]="year">
                                {{ year }}
                            </mat-option>
                        </mat-select>
                    </div>
                </div>
                <div class="col-xs-3 filter__item">
                    <div class="form-group mat-select-pill">
                        <mat-select class="mat-select-pill__select" [placeholder]="'Select Month' | translate"
                                    [disabled]="filterTime['type'] !== 'MONTH'"
                                    [(ngModel)]="filterParams.month"
                                    (ngModelChange)="setDateRange()">
                            <mat-option *ngFor="let month of months; let i = index" [value]="i">
                                {{ month | translate }}
                            </mat-option>
                        </mat-select>
                    </div>
                </div>
                <div class="col-xs-3 filter__item">
                    <div class="form-group mat-select-pill">
                        <mat-select class="mat-select-pill__select" [placeholder]="'Select time' | translate"
                                    [(ngModel)]="filterTime"
                                    (ngModelChange)="setDateRange()">
                            <mat-option *ngFor="let range of dateRangeOptions" [value]="range">
                                {{ range['name'] | translate }}
                            </mat-option>
                        </mat-select>
                    </div>
                </div>
                <div class="col-xs-3 filter__item">
                    <div class="form-group">
                        <button class="btn btn-export" (click)="export();">
                            <i class="far fa-file-download"></i>
                            {{ 'Export' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row mr-t--md">
    <div class="col-xs-12 card--child">
        <mental-component [isHome]="true" [filters]="filters"></mental-component>
    </div>
</div>

<div class="row mr-t--md mr-b--md">
    <div class="col-xs-12 card--child">
        <common-strains-component [isHome]="true" [filters]="filters" (setParams)="setFilterParams($event)"></common-strains-component>
    </div>
</div>

<div class="row mr-t--md mr-b--md">
    <div class="col-xs-12 card--child">
        <patients-timeline-component [isHome]="true" [exportData]="exportData" [filters]="filters"></patients-timeline-component>
    </div>
</div>

<div class="row mr-t--md mr-b--md">
    <div class="col-xs-12 card--child">
        <demographics-component [isHome]="true" [filters]="filters"></demographics-component>
    </div>
</div>